<template>

</template>

<script>
import Tagify from "@yaireo/tagify/dist/tagify.min.js";
import "@yaireo/tagify/dist/tagify.css";

export default {
    data() {
        return []
    },
    methods: {
        getColumns: function (table) {
            axios.post("/getcols", {table: table})
                .then(function (response) {
                    // handle success
                    console.log(response);
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
        },
    },
    mounted() {
        console.log("oi");

        let that = this;
        // $("#report_tables").change(function () {
        //     console.log(this);
        //     that.getColumns(this.value)
        // })

        // <script>
        // console.log("oi");
        $(document).ready(function () {
            $("#advanced").attr("placeholder",
                "select " + $("#report_columns").val() +
                " from " + $("#report_tables").val() +
                " Escreva os joins(EXEMPLO: INNER JOIN), condições(EXEMPLO: WHERE), grupos(EXEMPLO: GROUP BY) e ordem(EXEMPLO: ORDER BY) aqui"
            );
        });

        $(document).change(function () {
            $("#advanced").attr("placeholder",
                "select " + $("#report_columns").val() +
                " from " + $("#report_tables").val() +
                " Escreva os joins(EXEMPLO: INNER JOIN), condições(EXEMPLO: WHERE), grupos(EXEMPLO: GROUP BY) e ordem(EXEMPLO: ORDER BY) aqui"
            );
        });
    }
}
</script>

<style scoped>

</style>
